module.exports = __webpack_public_path__ + "static/img/MF.a3e7010f.svg";